import React from "react";

const Dashboard: React.FC = () => {
  return (
    <div>
      <div className="mx-auto max-w-7xl">
        {/* 3 column wrapper */}
        <div className="mx-auto w-full max-w-7xl grow lg:flex xl:px-2">
          <div className="shrink-0 border-base-300 py-6lg:w-96 lg:border-t-0 lg:pr-8 xl:pr-6">
            {/* Welcome */}
            <div className="overflow-hidden">
              <div className="px-8 pb-6 sm:p-6">
                <div>
                  <h1 className="text-3xl font-bold font-heading text-base-content">
                    <span className="font-light">Coach's</span> Corner
                  </h1>
                  <div className="bg-base-300 p-2 py-2 rounded-md mt-2">
                    <p className="text-base-content/70 text-xs font-mono">
                      Athlete, Session & Data Analytics Panel
                    </p>
                  </div>
                  <div className="bg-purple-200 p-2 py-2 rounded-md mt-2">
                    <p className="text-purple-600 text-xs font-mono">
                      Sam to provide desired features
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Training Squad */}
            <div className="bg-base-100 rounded-lg p-6 mt-3 items-center m-4">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-heading font-semibold">
                  Tori West
                </h3>
                <div className="text-xs ml-2 font-mono text-base-content/50">
                  image
                </div>
              </div>
              <div className="rounded-md">
                <p className="text-xs text-base-content/50 font-mono">
                  last log: 2nd July 2025
                </p>
              </div>
            </div>
          </div>

          <div className="flex-1 xl:flex mt-3">
            <div className="px-6 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6 bg-base-100 rounded-md shadow-sm">
              <p>Add Athlete Connections</p>
              <p>View Athlete Data, Logs & Charts</p>
              <p>Set Athlete Training Sessions</p>
              <p>Like & Comment on athlete logs</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
